import { defaultAxiosInstance, defaultAxiosInstanceV2 } from '../../../api/defaultInstance';

/**
 * 캠페???�비???�러 변???�수
 */
export function campaignServiceError(error) {
  if (error.response) {
    // ?�버 ?�답???�는 경우
    const message = error.response.data?.message || error.response.data?.error || '?�버 ?�류가 발생?�습?�다.';
    return { message, status: error.response.status, data: error.response.data };
  } else if (error.request) {
    // ?�청?� 보냈지�??�답??받�? 못한 경우
    return { message: '?�트?�크 ?�류가 발생?�습?�다.', status: null, data: null };
  } else {
    // ?�청 ?�정 �??�류가 발생??경우
    return { message: error.message || '?????�는 ?�류가 발생?�습?�다.', status: null, data: null };
  }
}

/**
 * 목록 조회
 * @param {Object} config - 캠페???�정 객체
 * @param {Object} params - 쿼리 ?�라미터
 * @returns {Promise<{items: Array, raw: Object}>}
 */
export async function list(config, params = {}) {
  try {
    const apiConfig = config.api.list;
    if (!apiConfig) {
      throw new Error(`list API가 config???�의?��? ?�았?�니?? (config.id: ${config.id})`);
    }

    // apiConfig.params?� ?�달??params�?병합 (apiConfig.params가 ?�선)
    const mergedParams = {
      ...params,
      ...(apiConfig.params || {})
    };

    // paramsTransformer 적용
    const transformedParams = apiConfig.paramsTransformer
      ? apiConfig.paramsTransformer(mergedParams)
      : mergedParams;

    const axiosInstance = apiConfig.version === 2 ? defaultAxiosInstanceV2 : defaultAxiosInstance;
    const response = await axiosInstance({
      method: apiConfig.method || 'GET',
      url: apiConfig.url,
      params: transformedParams
    });

    const result = response.data.data || response.data;
    // API ?�답??배열???�도 ?�고, { items: [...] } ?�식???�도 ?�음
    const items = Array.isArray(result) ? result : (result.items || []);
    return {
      items,
      raw: response
    };
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error('campaignService.list ?�류:', errorInfo);
    throw errorInfo;
  }
}

/**
 * ?�계 조회
 * @param {Object} config - 캠페???�정 객체
 * @param {Object} params - 쿼리 ?�라미터
 * @returns {Promise<{summary: Object, raw: Object}>}
 */
export async function count(config, params = {}) {
  try {
    const apiConfig = config.api.count;
    if (!apiConfig) {
      throw new Error(`count API가 config???�의?��? ?�았?�니?? (config.id: ${config.id})`);
    }

    // apiConfig.params?� ?�달??params�?병합 (apiConfig.params가 ?�선)
    const mergedParams = {
      ...params,
      ...(apiConfig.params || {})
    };

    // paramsTransformer 적용
    const transformedParams = apiConfig.paramsTransformer
      ? apiConfig.paramsTransformer(mergedParams)
      : mergedParams;

    const axiosInstance = apiConfig.version === 2 ? defaultAxiosInstanceV2 : defaultAxiosInstance;
    const response = await axiosInstance({
      method: apiConfig.method || 'GET',
      url: apiConfig.url,
      params: transformedParams
    });

    const result = response.data.data || response.data;
    return {
      summary: result || {},
      raw: response
    };
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error('campaignService.count ?�류:', errorInfo);
    throw errorInfo;
  }
}

/**
 * ?�션 ?�행 (submitted, paid, complete, refund, terminate, delete, custom)
 * @param {Object} config - 캠페???�정 객체
 * @param {string} actionType - ?�션 ?�??
 * @param {Object} payload - ?�청 ?�이로드
 * @returns {Promise<{status: string, raw: Object}>}
 */
export async function action(config, actionType, payload = {}) {
  try {
    let apiConfig;
    let requestPayload = payload;

    // custom ?�션??경우 payloadBuilder ?�용
    if (actionType === 'custom') {
      if (!payload.method || !payload.url) {
        throw new Error('custom ?�션?� method?� url???�요?�니??');
      }
      apiConfig = { method: payload.method, url: payload.url };
      requestPayload = payload.data || payload.params || {};
    } else {
      // ?�반 ?�션?� config.api?�서 찾기
      apiConfig = config.api[actionType];
      if (!apiConfig) {
        throw new Error(`${actionType} API가 config???�의?��? ?�았?�니?? (config.id: ${config.id})`);
      }
    }

    const method = apiConfig.method || 'POST';
    let response;

    if (method === 'DELETE') {
      // DELETE??data ?�는 params ?�션 지??
      if (payload.useParams) {
        response = await defaultAxiosInstance.delete(apiConfig.url, {
          params: requestPayload
        });
      } else {
        response = await defaultAxiosInstance.delete(apiConfig.url, {
          data: requestPayload
        });
      }
    } else if (method === 'GET') {
      response = await defaultAxiosInstance.get(apiConfig.url, {
        params: requestPayload
      });
    } else {
      // POST, PUT, PATCH ??
      response = await defaultAxiosInstance({
        method: method,
        url: apiConfig.url,
        data: requestPayload
      });
    }

    return {
      status: response.data.status === 200 ? 'success' : 'error',
      raw: response
    };
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error(`campaignService.action(${actionType}) ?�류:`, errorInfo);
    throw errorInfo;
  }
}

/**
 * ?�수 API ?�출 (extra)
 * @param {Object} config - 캠페???�정 객체
 * @param {string} name - extra API ?�름
 * @param {Object} params - 쿼리 ?�라미터 ?�는 ?�청 ?�이??
 * @returns {Promise<Object>}
 */
export async function extra(config, name, params = {}) {
  try {
    const apiConfig = config.api.extra?.[name];
    if (!apiConfig) {
      throw new Error(`extra API '${name}'가 config???�의?��? ?�았?�니?? (config.id: ${config.id})`);
    }

    const method = apiConfig.method || 'GET';
    let response;

    if (method === 'GET' || method === 'DELETE') {
      response = await defaultAxiosInstance({
        method: method,
        url: apiConfig.url,
        params: params
      });
    } else {
      response = await defaultAxiosInstance({
        method: method,
        url: apiConfig.url,
        data: params
      });
    }

    return response.data.data || response.data;
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error(`campaignService.extra(${name}) ?�류:`, errorInfo);
    throw errorInfo;
  }
}

/**
 * 캠페???�림 발송 로그 조회
 * @param {number} adCampaignMetaId - 캠페??메�? ID
 * @returns {Promise<Array>}
 */
export async function getNotificationLogs(adCampaignMetaId) {
  try {
    const response = await defaultAxiosInstance({
      method: 'GET',
      url: '/admin/campaign/notification/logs',
      params: { adCampaignMetaId }
    });

    return response.data.data?.logs || [];
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error('campaignService.getNotificationLogs ?�류:', errorInfo);
    throw errorInfo;
  }
}

/**
 * 캠페???�림 발송
 * @param {Object} params - 발송 ?�라미터
 * @param {number} params.adCampaignMetaId - 캠페??메�? ID
 * @param {string} params.templateCode - ?�플�?코드
 * @param {number} params.purchaseAmount - 구매 금액
 * @returns {Promise<Object>}
 */
/**
 * 환불 처리
 * @param {Object} config - 캠페인 설정 객체
 * @param {Array} refundItems - [{ adCampaignMetaId, refundedAmount, refundType }]
 * @returns {Promise<{status: string}>}
 */

export async function submitRefund(config, refundItems) {
  try {
    const apiConfig = config.api.refund;
    if (!apiConfig) {
      throw new Error(`refund API가 config에 정의되지 않았습니다. (config.id: ${config.id})`);
    }

    // 포인트 결제 건은 campaigns/refund 제외 (executeCancel + pointPaymentCancel로 처리)
    const nonPointItems = refundItems.filter(i => i.paymentType !== 'point');
    if (nonPointItems.length === 0) return { status: 'success' };

    const apiItems = nonPointItems.map(({ adCampaignMetaId, refundedAmount, refundType }) => ({
      adCampaignMetaId,
      refundedAmount,
      refundType,
    }));

    if (apiConfig.version === 2 && apiConfig.type) {
      // by-type/status 엔드포인트
      const payload = {
        type: apiConfig.type,
        action: 'refund',
        ids: apiItems.map(i => i.adCampaignMetaId),
        items: apiItems,
      };
      await defaultAxiosInstanceV2.post(apiConfig.url, payload);
    } else if (apiConfig.version === 2) {
      await defaultAxiosInstanceV2.post(apiConfig.url, { items: apiItems });
    } else {
      await defaultAxiosInstance.post(apiConfig.url, { items: apiItems });
    }

    return { status: 'success' };
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error('campaignService.submitRefund 오류:', errorInfo);
    throw errorInfo;
  }
}

export async function sendNotification({ adCampaignMetaId, templateCode, userId, productName, submittedAt, purchaseAmount }) {
  try {
    const response = await defaultAxiosInstance({
      method: 'POST',
      url: '/admin/campaign/notification',
      data: { adCampaignMetaId, templateCode, userId, productName, submittedAt, purchaseAmount }
    });

    return response.data;
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error('campaignService.sendNotification ?�류:', errorInfo);
    throw errorInfo;
  }
}

/**
 * 캠페인 메모 저장
 * @param {number} adCampaignMetaId - 캠페인 메타 ID
 * @param {string|null} memo - 메모 내용 (null이면 메모 비움)
 * @returns {Promise<Object>}
 */
export async function saveMemo(adCampaignMetaId, memo) {
  try {
    const response = await defaultAxiosInstance({
      method: 'PUT',
      url: `/advertisement/admin/campaigns/${adCampaignMetaId}/memo`,
      data: { memo }
    });

    return response.data;
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error('campaignService.saveMemo ?�류:', errorInfo);
    throw errorInfo;
  }
}

/**
 * 송장 메모 저장
 * @param {number} id - ad_payment_transaction 식별자
 * @param {string|null} memo - 메모 내용 (null이면 메모 비움)
 * @returns {Promise<Object>}
 */
export async function saveInvoiceMemo(id, memo) {
  try {
    const response = await defaultAxiosInstance({
      method: 'PUT',
      url: `/invoice/${id}/memo`,
      data: { memo }
    });

    return response.data;
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error('campaignService.saveInvoiceMemo ?�류:', errorInfo);
    throw errorInfo;
  }
}

/**
 * 그룹 액션 실행 (campaignType별 순차 처리)
 * @param {Object} config - 캠페인 설정 객체
 * @param {string} actionType - 액션 타입 (submitted, complete, paid, refund, delete 등)
 * @param {Array} selectedIds - 선택된 아이템 ID 배열
 * @param {Array} allItems - 전체 아이템 배열
 * @returns {Promise<{status: string}>}
 */
export async function groupedAction(config, actionType, selectedIds, allItems) {
  try {
    // 선택된 아이템만 필터
    const selectedItems = allItems.filter(item =>
      selectedIds.includes(item.adCampaignMetaId)
    );

    // campaignType 기준으로 그룹핑
    const groups = {};
    selectedItems.forEach(item => {
      const type = item.campaignType || 'follow_on_daangn';
      if (!groups[type]) {
        groups[type] = [];
      }
      groups[type].push(item);
    });

    // 액션 설정 찾기
    const actionConfig = config.actions?.find(a => a.actionType === actionType);
    if (!actionConfig) {
      throw new Error(`${actionType} 액션이 config에 정의되지 않았습니다. (config.id: ${config.id})`);
    }

    if (!actionConfig.groupPayloadBuilder) {
      throw new Error(`${actionType} 액션에 groupPayloadBuilder가 정의되지 않았습니다.`);
    }

    if (selectedItems.length === 0) {
      throw new Error('선택된 항목을 찾을 수 없습니다.');
    }

    // 각 타입 그룹에 대해 순차적으로 호출
    for (const [type, typeItems] of Object.entries(groups)) {
      const typeIds = typeItems.map(item => item.adCampaignMetaId);
      const payload = actionConfig.groupPayloadBuilder(type, typeIds, typeItems);
      console.log(`[groupedAction] ${actionType} — type: ${type}, ids: ${typeIds}, payload:`, payload);
      const result = await action(config, actionType, payload);
      if (result.status !== 'success') {
        throw new Error(`${type} 타입 ${actionType} 처리에 실패했습니다. (서버 응답 오류)`);
      }
    }

    return { status: 'success' };
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error(`campaignService.groupedAction(${actionType}) 오류:`, errorInfo);
    throw errorInfo;
  }
}

/**
 * URL 단위 리뷰삭제 환불 처리 (v2 신규 API)
 * @param {Array} items - [{ adReviewDeleteId, refundType: 'FULL'|'PARTIAL', refundedAmount? }]
 * @param {string} [idempotencyKey] - 멱등성 키 (모달 세션 단위로 고정해야 멱등성 보장)
 * @returns {Promise<Object>}
 */
export async function submitUrlRefund(items, idempotencyKey) {
  try {
    const config = {};
    if (idempotencyKey) {
      config.headers = { 'Idempotency-Key': idempotencyKey };
    }
    const response = await defaultAxiosInstanceV2.post(
      '/advertisement/admin/reviewDeletes/refund',
      { items },
      config
    );
    return response.data?.data ?? response.data ?? {};
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error('campaignService.submitUrlRefund 오류:', errorInfo);
    throw errorInfo;
  }
}

/**
 * 그룹 환불 처리 (campaignType별 순차 처리)
 * @param {Object} config - 캠페인 설정 객체
 * @param {Array} refundItems - [{ adCampaignMetaId, refundedAmount, refundType, paymentType, campaignType }]
 * @returns {Promise<{status: string}>}
 */
export async function groupedSubmitRefund(config, refundItems) {
  try {
    // 포인트 결제 건은 제외 (포인트는 기존 walletService 흐름 유지)
    const nonPointItems = refundItems.filter(i => i.paymentType !== 'point');
    if (nonPointItems.length === 0) return { status: 'success' };

    // campaignType 기준 그룹핑
    const groups = {};
    nonPointItems.forEach(item => {
      const type = item.campaignType || 'follow_on_daangn';
      if (!groups[type]) {
        groups[type] = [];
      }
      groups[type].push(item);
    });

    const apiConfig = config.api.refund;
    if (!apiConfig) {
      throw new Error(`refund API가 config에 정의되지 않았습니다. (config.id: ${config.id})`);
    }

    // 타입별 v2 환불 API 순차 호출
    for (const [type, typeItems] of Object.entries(groups)) {
      const apiItems = typeItems.map(({ adCampaignMetaId, refundedAmount, refundType }) => ({
        adCampaignMetaId,
        refundedAmount,
        refundType,
      }));
      const payload = {
        type,
        action: 'refund',
        ids: apiItems.map(i => i.adCampaignMetaId),
        items: apiItems,
      };
      await defaultAxiosInstanceV2.post(apiConfig.url, payload);
    }

    return { status: 'success' };
  } catch (error) {
    const errorInfo = campaignServiceError(error);
    console.error('campaignService.groupedSubmitRefund 오류:', errorInfo);
    throw errorInfo;
  }
}
